var generateStyle = function generateStyle(componentTheme) {
  return {
    moderateButton: {
      "float": 'right'
    },
    avatarRow: {
      display: 'flex',
      alignItems: 'center'
    },
    avatarName: {
      marginLeft: componentTheme.avatarNameMargin,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontWeight: 'initial'
    },
    tableDataItem: {
      ':not(:first-child)': {
        paddingTop: componentTheme.tableDataItemPadding
      }
    }
  };
};
export default generateStyle;